import type { HTMLAttributes } from "react";
import { cn } from "./cn.js";

export function Badge({
  tone = "neutral",
  className,
  ...props
}: HTMLAttributes<HTMLSpanElement> & {
  tone?: "neutral" | "success" | "warning" | "danger" | "info";
}) {
  return <span className={cn("yatta-badge", `yatta-badge-${tone}`, className)} {...props} />;
}
